export const IconSendPaperPlane = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_2095_36094)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9454 1.57781C16.0334 1.94581 16.0142 2.33461
      15.8942 2.69461L11.9246 14.6034C11.7908 15.0109 11.5314 15.3655 11.1836 15.6164C10.8358 15.8673
        10.4175 16.0017 9.98863 16.0002C9.44425 15.9985 8.9226 15.7817 8.53743 15.397L6.61743 13.469L4.47983
        15.0402C4.36098 15.1293 4.21965 15.1836 4.07168 15.197C3.92371 15.2103 3.77495 15.1822 3.64206
          15.1157C3.50918 15.0493 3.39742 14.9472 3.31931 14.8208C3.2412 14.6944 3.19983 14.5488 3.19983
          14.4002V10.9442L11.563 4.75221C11.6475 4.6897 11.7188 4.61116 11.7729 4.52109C11.8271 4.43101
            11.8629 4.33116 11.8784 4.22724C11.894 4.12331 11.8889 4.01734 11.8634 3.91538C11.838 3.81342
            11.7927 3.71747 11.7302 3.63301C11.6677 3.54854 11.5892 3.47721 11.4991 3.4231C11.409 3.36898
              11.3092 3.33314 11.2053 3.31761C11.1013 3.30209 10.9954 3.30718 10.8934 3.33261C10.7915
              3.35804 10.6955 3.4033 10.611 3.46581L2.61583 9.38581L0.612633 7.47541C0.362121 7.23024
                0.178895 6.92475 0.0805694 6.5883C-0.0177558 6.25186 -0.0278727 5.89577 0.0511912 5.55429C0.130255
                5.2128 0.295841 4.8974 0.532028 4.6384C0.768216 4.37941 1.06706 4.18553 1.39983 4.07541L13.307
                  0.105807C13.5768 0.0154814 13.8624 -0.0175608 14.1457 0.008793C14.429 0.0351468 14.7036 0.120317
                  14.9521 0.258857C15.2005 0.397398 15.4174 0.586261 15.5887 0.813371C15.76 1.04048 15.8821 1.30084
                    15.947 1.57781H15.9454Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2095_36094">
        <rect width="16" height="16" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
)
